module.exports = "<div class=\"slider-container\" #slider (scroll)=\"scrolling($event)\">\n  <div class=\"slider\" #slider [style.width]=\"sliderWidth\">\n    <app-opacity-colors *ngFor=\"let colorGroup of colorGroups\" [colorGroup]=\"colorGroup\"></app-opacity-colors>\n  </div>\n</div>\n<app-modal [modal]=\"eliteModal\" #eliteToolTip></app-modal>\n<!-- <app-modal [modal]=\"waterguardModal\" #waterguardToolTip></app-modal> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/visualizer/color-groups/color-groups.component.html
// module id = ./src/app/components/visualizer/color-groups/color-groups.component.html
// module chunks = main